import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NavbarComponent } from './navbar/navbar.component';

@Component({
  selector: 'app-secure',
  imports: [CommonModule, RouterOutlet,NavbarComponent],
  standalone: true,
  templateUrl: './secure.component.html',
  styleUrl: './secure.component.scss'
})
export class SecureComponent {

}
